import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

export type GmailUserWithoutAvatar = {
  userId: string;
  firstName: string;
  lastName: string;
  nickname: string;
  email: string;
  gmailComposeUrl: string;
  contactsSearchUrl: string;
};

@Component({
  selector: 'admin-gmail-missing-avatars',
  templateUrl: './gmail-missing-avatars.component.html',
  styleUrls: ['./gmail-missing-avatars.component.scss']
})
export class AdminGmailMissingAvatarsComponent implements OnInit {
  public loading = false;
  public error = '';
  public users: GmailUserWithoutAvatar[] = [];

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    this.http.get<GmailUserWithoutAvatar[]>('/admin/gmail-users-without-avatar').subscribe(
      (resp) => {
        this.users = resp || [];
        this.loading = false;
      },
      (err) => {
        this.error = err?.error?.message || err?.message || 'Could not load users.';
        this.users = [];
        this.loading = false;
      }
    );
  }

  displayName(u: GmailUserWithoutAvatar): string {
    const name = `${u.firstName || ''} ${u.lastName || ''}`.trim();
    return name || u.email || u.userId;
  }
}
